import { Component } from 'react';
import { withLeaflet } from 'react-leaflet';

class PanToOnActivePlace extends Component {
  componentDidUpdate(prevProps) {
    const { activePlace, leaflet } = this.props;
    if (
      activePlace &&
      activePlace !== prevProps.activePlace &&
      leaflet.map &&
      activePlace.coordinates &&
      activePlace.coordinates[0]
    ) {
      const { lat, lon } = activePlace.coordinates[0];
      leaflet.map.setView([lat, lon], leaflet.map.getZoom(), { animate: true });
    }
  }
  render() {
    return null;
  }
}

export default withLeaflet(PanToOnActivePlace); 